module.exports = __webpack_public_path__ + "34feea3f04bc2b7f90a64e16a9980d37.jpg";